import React, { Component } from 'react';
import InputForm from './InputForm';
import logo from './logohola.png';
import {Link} from "react-router-dom";
import Tabs from './forminput/tabs';
import Accordion from './Accordion'
import { AccordionItem } from 'reactstrap';
import formularioJSON from '../data/formulario.json' // se usa para cargar datos en la base de datos
// import igtm from '../data/igtm.json' // se usa para cargar datos en la base de datos
// import fairConfigData from '../data/fair.json' // se usa para cargar datos en la base de datos

var urlSplit = "";
var urlElement = "";


class CustomForm extends Component {

    state = {
        title: '', //Título de la aplicación
        fileJson: "", //Nombre del archivo json
        formJson: [], //Descripción de los inputs para el formulario del Json
        outputFile: "", // Nombre de archivo txt por defecto
        url: "", //url del back
        inputsForm: [], //Descripción de los inputs para el formulario
        fileTxt: "", //Nombre del fichero
        mapa: new Map(), //información de las líneas en un map
        mapaBloques: new Map(), //Mapa de la posición de los bloques del archivo de configuración txt
        posiciones : [], //Posiciones de los bloques del archivo de configuración txt
        posiciones_agrupador : [], //Posiciones de los agrupadores del archivo json
        mapa_agrupador : new Map(), //Mapa con los títulos y posiciones de los agrupadores del archivo json
        mapa_agrupador_child : new Map(), //Mapa con los child y posiciones de los agrupadores del archivo json
        final: "", //Posición del final de la última pestaña con agrupadores
        texto: "", //Texto de los campos
        nombreFichero: "", //Nombre del fichero
        lineas: "",//Toda la información del archivo de configuración txt
        mapaLineas: new Map(), //Mapa de todas las líneas del archivo de configuración txt
        publicUrl: "",//Url base de react
        responseData: ""
    }

    constructor(props) {

    urlSplit = window.location.pathname.split('/');
    for (var i = 0; i < urlSplit.length; i++) {
        urlElement = urlSplit[i];
    }
    super(props);

    //Inicializamos todas las variables
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state.title = (props.title === undefined || props.title == null) ? 'Aplicacion Ferias Edición' : props.title;
    this.state.outputFile = props.output;
    this.state.url = props.url;
    this.state.fileJson = props.fileJson;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state.fileTxt = urlElement;
    this.state.outputFile = props.output;
    this.state.publicUrl = props.publicUrl;
    }

    async leerDatos(){
        //Leemos el archivo desde el back y le quitamos las líneas vacías y las líneas de asteriscos
        await fetch(`${this.state.url}/api/v1/config-planner/fair/${this?.state?.fileTxt}`)
        .then(response => response.json())
        .then(response => {
            if (response !== false){
            this.setState({ lineas: JSON.parse(response.config)});
            var lineastemp = [];
            for(var i = 0; i< this?.state.lineas.Lineas.length; i++){
                if(this.state.lineas.Lineas[i].value !== "" ){
                    if(!this.state.lineas.Lineas[i].value.startsWith("###")){
                    lineastemp.push(this.state.lineas.Lineas[i]);
                    }
                }
            };
            this.state.lineas.Lineas = lineastemp;
            this.state.lineas.NumLineas = lineastemp.length;
            this.setState({ mapa: this.inicializarTXTArray(this.state.lineas)});
            this.setState({ mapaBloques: this.inicializarPestanasArray(this.state.lineas)});
            this.setState({ responseData: response })
        }
        })
        .then(() => {
            this.setState({ formJson: formularioJSON });
            this.setState({ inputsForm: this.initializeForm(this.state.formJson) });
        }) ;
    }

    componentDidMount = () => {
        this.leerDatos();
    }

    //Saca la información de las líneas y las devuelve en un map
    inicializarTXTArray(LinesArrayTemp){
        var parametro = "";
        var valor = "";
        var map = new Map();
        for (var i = 0; i < LinesArrayTemp.Lineas.length; i++) {
            var line = LinesArrayTemp.Lineas[i];
            var partes= line.value.split('=');
            for (var j = 0; j < partes.length; j++) {
                if (j===0){
                        parametro = partes[j]
                }
                else {
                    partes[j].replace(/[\n\r]/g,'');
                    valor = partes[j];
                }
            }
            map.set(parametro,valor);

        }
        return map;
    }

    //Saca la información de la posición de las pestañas y las devuelve en un map
    inicializarPestanasArray(LinesArrayTemp){
        var map = new Map();
        this.setState({ final: LinesArrayTemp.Lineas.length});

        for (var i = 0; i < LinesArrayTemp.Lineas.length; i++) {

            var line = LinesArrayTemp.Lineas[i];
            var partes = line.value.split('=');
            //Para las pestañas no tenemos valor por lo que al hacer el split solo hay un valor
            if (partes.length === 1 ){
                //guardamos los valores parametro y posicion donde nos lo hemos encontrado
                map.set(i,partes);
                if(partes !== "" ){
                    if(!partes[0].startsWith("###")){
                        if(partes[0].startsWith("##")){
                            partes[0] = partes[0].substring(0, partes[0].length -3);
                            partes[0] = partes[0].substring(3, partes[0].length);
                            this.state.posiciones.push(i);
                        }else{
                            this.state.posiciones.push(i);
                        }
                    }
                }
            }
        }
        return map;
    }

    //Inicializa el formulario a partir del json
    initializeForm(dataJson) {
        //console.log(" Inicio de la carga del json del Formulario");
        var jsonLines = {};
        var jsonLine = {};

        var elementKeys = Object.keys(dataJson);
        var numLine = 0;
        var nombreAgrupador="";
        var child="";

        
        for (var i = 0; i < elementKeys.length; i++) {
            var element = elementKeys[i];
            var dataElement = dataJson[element];
            child = dataElement.child;
            var dataKeys = Object.keys(dataElement);
            var defaultvalue="";

            for (var j = 0; j < dataKeys.length; j++) {
                var field = dataKeys[j];
                var value = dataElement[field];
                if (field.toLowerCase() === 'domain'){
                    nombreAgrupador = value;
                    defaultvalue = this.state.mapa.get(value);
                }
                //si es un campo oculto es un agrupador
                if (field.toLowerCase() === 'hidden'){
                    this.state.posiciones_agrupador.push(i);
                    this.state.mapa_agrupador.set ( i,nombreAgrupador);
                    this.state.mapa_agrupador_child.set(i, child);
                }
                if (field.toLowerCase() === 'text'){
                }

                //asignamos el valor al valor por defecto
                if (field === 'defaultValue'){
                    value = defaultvalue;
                    dataElement[field] = value;
                }

                if (field.toLowerCase() !== 'line') {
                    continue;
                } else {
                    if (value !== numLine) {
                        if (numLine === 0) {
                            numLine = value;
                            jsonLine[element] = dataElement;

                        } else {
                            jsonLines[numLine] = jsonLine;
                            jsonLine = {};
                            jsonLine[element] = dataElement;
                            numLine = value;
                            if (i === elementKeys.length - 1) {
                                jsonLines[numLine] = jsonLine;
                            }

                        }
                    } else {
                        jsonLine[element] = dataElement;
                        if (i === elementKeys.length - 1) {
                            jsonLines[numLine] = jsonLine;
                        }
                    }
                }
            }
        }
    //console.log(" Fin de la carga del json del Formulario");
        return jsonLines;
    }
    // Inicializa la información del txt a partir del json
    inicializarTXTJSon(entrada) {
        var elementKeys = Object.keys(entrada);
        var map = new Map();
        var valor = "";

        for (var i = 0; i < elementKeys.length; i++) {
            var element = elementKeys[i];
            var dataElement = entrada[element];
            var dataKeys = Object.keys(dataElement);

        if (element === 'NombreFichero'){
            this.state.nombreFichero = JSON.stringify(dataElement);
        }

        if (element === 'NumLineas'){
            this.state.NumLineas = JSON.stringify(dataElement);
        }

        if (element === 'Lineas'){
            for (var j = 0; j < dataKeys.length; j++) {
                var field = dataKeys[j];
                var value = JSON.stringify(dataElement[field]);
                var partes =value.split('":');
                
                for (var x = 0; x < partes.length; x++) {
                    if (x===0){}
                    else {
                        valor = partes[x];
                        if (valor.startsWith('"#') ) {
                            var valorLinea= valor.substring(1,valor.length-2);
                            this.state.mapaLineas.set(j,valorLinea);
                        } else {
                        // el valor es tipo "valor"} por lo que tenemos que quitar parte del contenido
                        //valor tiene un patron "campo=valor"
                           var partesCampoValor =valor.substring(1,valor.length-2);
                           var partesCampoValorTemp = partesCampoValor.split("=");
                           var campo ="";
                           var valorDeCampo ="";

                           for (var z = 0; z < partesCampoValorTemp.length; z++) {
                                if (z===0){
                                    campo = partesCampoValorTemp[z];
                                } else {
                                    valorDeCampo = partesCampoValorTemp[z];

                                }
                            }
                            //nos guardamos las lineas de como nos ha llegado del back con el nombre del campo
                            this.state.mapaLineas.set(j,campo);
                            //creamos un mapa de campo -valor para mostrar
                            map.set(campo,valorDeCampo);
                        }
                    }
                }
            }
            //console.log("Fin Carga de campos");
         }
    }
    //console.log("Fin de la carga de Json de datos de fichero");

    return map;
    }

    result = {
    }

    handleSubmit(event) {
        event.preventDefault();
        this._saveFileJSON();
    }

    async leerTxt() {
        const lectura = await fetch(`${this.state.url}/api/v1/config-planner/fair/${this?.state?.fileTxt}`,{
            method: "GET",
        });
        const lineas = await lectura.json();
        this.setState({ lineas: JSON.parse(lineas.config)});

        return JSON.parse(lineas.config);
    }

    generateOutputTxt(data){
        var dataTxt="";
        var elementsKeys = Object.keys(data);

        for (var i = 0; i < elementsKeys.length; i++) {
            var element = elementsKeys[i];
            var dataElement = data[element];
            //aqui tenemos propiedad y valor
            dataTxt = dataTxt + element + "="+ dataElement+"\n";
        }
        return dataTxt;
    }

    generateOutput(data){
        this.inicializarTXTJSon(this.state.lineas);
        var dataJson= "{";
        var mapaResultados = new Map();
        // cargamos los datos que se estan mostrando
        var elementsKeys = Object.keys(data);

       for (var i = 0; i < elementsKeys.length; i++) {
            var element = elementsKeys[i];
            var dataElement = data[element];
            //aqui tenemos propiedad y valor
            mapaResultados.set(element,dataElement);
        }

        dataJson=dataJson + "\"NombreFichero\":  "+this.state.nombreFichero+",";
        dataJson=dataJson + "\"NumLineas\":  "+this.state.NumLineas+",";
        dataJson=dataJson + "\"Lineas\": [";
        this.state.mapaLineas.forEach((value, key, map2) => {
            if (value.startsWith('#') ){
                dataJson=dataJson + " {  \"value\": \"" +value+ "\"},"
            }else{
                if (value===""){
                    dataJson=dataJson + " {  \"value\": \"" +value+"\"},"
                }else if(mapaResultados.get(value)!==undefined){
                    dataJson=dataJson + " {  \"value\": \"" +value+"="+mapaResultados.get(value)+"\"},"
                }else{
                    dataJson=dataJson + " {  \"value\": \""+this.state.lineas.Lineas[key].value+"\"},"
                }
            }
        });
        dataJson = dataJson.substring(0, dataJson.length - 1);
        dataJson = dataJson +"]";
        dataJson = dataJson + "}";
        return dataJson;
    }

    async save(dataString){
        const urlLocal = "http://localhost:3002"
        const urlPRE = "https://preapinewplanificador.holaislascanarias.com"
        const urlPROD = "https://apinewplanificador.holaislascanarias.com"

        const id = this.state.responseData.id;
        const fairName = this.state.responseData.fair;

        fetch(`${this.state.url}/api/v1/config-planner/${id}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "accept": "*/*"
            },
            body: JSON.stringify({
                "config": dataString
            })
        }).then(res => res.json())
        .then(json => {
            const response = json;
            if (response === null) {
                alert (`Error en el guardado: ${response.type} ${response.message}`);
            } else {
                alert("Datos guardados correctamente")
            }
        })
    }

    generateOutputJSON() {
        const data = { ...this.result };
        if (data.TABLE) {
            data.TABLE = data.TABLE.filter(item => !item.disabled);
        }
        return data;
    }

    /**
     * If this returns empty array, it means everything is ok, else returns an array of errors
     * @param {any[]} data The output of generateOutputJSON()
     * @returns {{reason: string, key: string}[]}
     */
    findValidationErrors(data) {
        const emptyKeys = Object.keys(data).filter(key => key !== 'TABLE' && !data[key]);
        return Object.keys(this.state.formJson)
            .filter(key => {
                const el = this.state.formJson[key];
                return el.domain && el.isMandatory && emptyKeys.some(key => el.domain === key);
            })
            .map(key => ({
                reason: 'MANDATORY',
                key
            }));
    }

    /**
     *
     * @param {{reason: string, key: string}[]} validationErrors
     */
    showValidationErrors(validationErrors) {
        validationErrors.filter(result => result.reason === 'MANDATORY').forEach(result => alert(`The field ${result.key} is required`))
    }

    _saveFileJSON = () => {
        const data = this.generateOutputJSON();
        // console.log('saveFileJSON data', data)
        var dataJson = this.generateOutput(data);
        // console.log("generado el Json de salida");
        this.save(dataJson);
    }

    render() {
        var contador_agrupadores=0;
        var final_pestana=0;
        return (
            <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="kt-portlet">
                            <div className="kt-portlet__head-label">
                            <Link to={{pathname: `${this.state.publicUrl}/` }}><img src={logo} alt="Aplicacion de Ferias"/></Link>
                                <h3 className="kt-portlet__head-title">{this.state.title} - {this.state.fileTxt}
                                </h3>
                            </div>

                            <form className="kt-form kt-form--fit" action="" onSubmit={this.handleSubmit}>
                                <div className="kt-portlet__body">
                                
                                {this.state.mapaBloques.size >= 2 && this.state.posiciones.length >= 2 ?
                                //coge las pestañas a partir del txt
                                    <Tabs label="Pestañas" renderActiveOnly={false} forceRender={false} key="test" forceRenderTabPanel={false} >
                                    {this.state.posiciones.map((posicion,x) => (
                                        //pestañas
                                        <div id  = {posicion} key= {this.state.mapaBloques.get(posicion)} label={this.state.mapaBloques.get(posicion)}>
                                            {Object.keys(this.state.inputsForm).map((element, i) => {

                                                //miramos la posicion de las pestañas,
                                                // en caso de que sea la ultima pestaña, entonces hay que filtrar con el final del fichero
                                                this.state.posiciones[x+1] === undefined  ? final_pestana = this.state.final+160 : final_pestana = this.state.posiciones[x+1];
                                                var inicio_pestana = this.state.posiciones[x];
                                                //Provisional porque en la pestana 3 el último campo se pone en la pestana 4
                                                if(x===3){
                                                    final_pestana = final_pestana +30;
                                                }
                                                if(x===4){
                                                    inicio_pestana = inicio_pestana + 30;
                                                }
                                                return(
                                                    <div key={"div-" + i} className="form-group row"  id={this.state.mapaBloques.get(posicion)} style={posicion === 0 ?{display: "block"}:{display: "none"}}>
                                                    {
                                                        
                                                        //con este filtro quitamos los agrupadores que se pasan del limite de la pestaña
                                                        this.state.posiciones_agrupador.filter (
                                                            number => (
                                                                number >= inicio_pestana //inicio de la pestaña
                                                                &&
                                                                number <= final_pestana  //fin de la pestaña
                                                        ))
                                                        .map((posicion_agrupador,t) => {
                                                            contador_agrupadores = contador_agrupadores +1;
                                                            return(<div key={t} class={this.state.mapa_agrupador_child.get(posicion_agrupador) === undefined ? 'acordeon' : 'child'}><div id={"visible" + "-" + this.state.mapa_agrupador.get(posicion_agrupador)} class="check-visible">{
                                                                Object.keys(this.state.inputsForm[element]).map((object, j) => (
                                                                (() => {
                                                                        if(
                                                                            j> posicion_agrupador - contador_agrupadores && j<this.state.posiciones_agrupador[contador_agrupadores]-contador_agrupadores)
                                                                            {
                                                                                //console.log(object);
                                                                                if(object.includes("VISIBLE")){
                                                                                    if(object.indexOf('_',object.indexOf('VISIBLE')) === -1){
                                                                                        return (
                                                                                            <InputForm key={"form-" + j} ref={object} dataJson={this.state.inputsForm[element]} elementForm={object} dataResult={this.result} showLabel={false} />
                                                                                        )
                                                                                    }
                                                                                }
                                                                            }else if(this.state.posiciones[x+1]=== undefined &&
                                                                                j> posicion_agrupador - contador_agrupadores && posicion_agrupador === this.state.posiciones_agrupador[this.state.posiciones_agrupador.length-1])
                                                                            {
                                                                                if(object.includes("VISIBLE")){
                                                                                    if(object.indexOf('_',object.indexOf('VISIBLE')) === -1){
                                                                                        return (
                                                                                            <InputForm key={"form-" + j} ref={object} dataJson={this.state.inputsForm[element]} elementForm={object} dataResult={this.result} showLabel={false} />
                                                                                        )
                                                                                    }
                                                                                }
                                                                            }
                                                                    })()
                                                            ))}</div><Accordion  id  = {t} key= {t} title={this.state.mapa_agrupador.get(posicion_agrupador)} >{
                                                                //aqui rellenamos los que necesitemos
                                                                    Object.keys(this.state.inputsForm[element]).map((object, j) => (
                                                                        (() => {
                                                                                if(
                                                                                    j> posicion_agrupador - contador_agrupadores && j<this.state.posiciones_agrupador[contador_agrupadores]-contador_agrupadores)
                                                                                    {     

                                                                                    if(!object.includes("VISIBLE") || object.indexOf('_',object.indexOf('VISIBLE')) !== -1){
                                                                                            return (
                                                                                                <AccordionItem id  = {j} key= {j}  title ={j} >
                                                                                                <InputForm key={"form-" + j} ref={object} dataJson={this.state.inputsForm[element]} elementForm={object} dataResult={this.result} />
                                                                                                </AccordionItem>
                                                                                            )
                                                                                    }
                                                                                    }else if(this.state.posiciones[x+1]=== undefined &&
                                                                                        j> posicion_agrupador - contador_agrupadores && posicion_agrupador === this.state.posiciones_agrupador[this.state.posiciones_agrupador.length-1])
                                                                                    {
                                                                                        if(!object.includes("VISIBLE") || object.indexOf('_',object.indexOf('VISIBLE')) !== -1){
                                                                                            return (
                                                                                                <AccordionItem id  = {j} key= {j}  title ={j} >
                                                                                                <InputForm key={"form-" + j} ref={object} dataJson={this.state.inputsForm[element]} elementForm={object} dataResult={this.result} />
                                                                                                </AccordionItem>
                                                                                            )
                                                                                    }
                                                                                    }
                                                                            })()
                                                                    ))
                                                                }
                                                                </Accordion></div>
                                                            )
                                                        })
                                                }
                                        </div>
                                        )}
                                    )}
                                </div>
                            ))}
                                    </Tabs>
                                : null }
                                </div>

                                {this.props.standalone === true ?
                                    <div className="kt-portlet__foot">
                                        <div className="kt-form__actions">
                                        {<div id="mensaje-guardado" style={{display: "none"}}>Datos Guardados</div>}
                                        <Link to={{pathname: `${this.state.publicUrl}/` }} className="btn btn-success">VOLVER ATRAS</Link>
                                        {<input className="btn btn-success" type="submit" value="Guardar Datos" />}
                                        </div>
                                        </div>
                                    : null}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CustomForm;